import htmx from 'htmx.org'
import 'htmx-ext-preload'

// window.htmx = htmx
htmx.onLoad(function () {
    htmx.on('htmx:configRequest', function(evt) {
        evt.detail.parameters.lang = window.customData.lang
    })

    htmx.on('htmx:beforeRequest', function (event) {
        try {
            const params = JSON.parse(event.detail.elt.getAttribute('hx-vals'))
            if (!params.cache) {
                return
            }

            const timestamp = Math.round(new Date().getTime() / 1000)
            if (timestamp < (params.cache.timestamp + params.cache.ttl)) {
                event.preventDefault()
            }
        } catch {}
    })
})

document.body.addEventListener('htmx:configRequest', function(evt) {
    evt.detail.parameters.lang = window.customData.lang
})
